module["exports"] = [
  "/30[0-5]#-######-###L/",
  "/368#-######-###L/"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en/credit_card/diners_club.js
// module id = 1200
// module chunks = 0